






















































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import TenantsMobileFooter from '@/components/Layout/Tenant/TenantsMobileFooter.vue';
import { Mutations } from '@/ts/store/Constants';
import GlobalOverlayMethods from '@/mixins/GlobalOverlayMethods.vue';

@Component({
    components: {
        TenantsMobileFooter,
    },
    computed: {
        ...mapGetters({
            closeButtonVisibility: 'Viewport/getBottomNavigationCloseButton',
        }),
    },
})
export default class MobileFooter extends Mixins(
    GlobalOverlayMethods,
) {
    constructor() {
        super();
    }

    get isStaff() {
        return this.$store.getters['User/getUser']
            ? !this.$store.getters['User/getUser'].isTenant
            : false;
    }

    get unreadMessageCount(): string {
        return this.$store.getters['Messages/unreadMessageCount'];
    }

    get messagesActive() {
        if (this.$route.name === 'messages') {
            return { 'hoc-mobile-footer__active': true };
        } else {
            return { 'hoc-mobile-footer__active': false };
        }
    }

    get staffMessagesActive() {
        if (this.$route.name === 'inbox') {
            return { 'hoc-mobile-footer__active': true };
        } else {
            return { 'hoc-mobile-footer__active': false };
        }
    }

    get calendarActive() {
        if (this.$route.name === 'calendar') {
            return { 'hoc-mobile-footer__active': true };
        } else {
            return { 'hoc-mobile-footer__active': false };
        }
    }

    get dashboardActive() {
        if (this.$route.name === 'dashboard') {
            return { 'hoc-mobile-footer__active': true };
        } else {
            return { 'hoc-mobile-footer__active': false };
        }
    }

    get unitsActive() {
        if (this.$route.name === 'units') {
            return { 'hoc-mobile-footer__active': true };
        } else {
            return { 'hoc-mobile-footer__active': false };
        }
    }

    get ticketsActive() {
        if (this.$route.name === 'tickets' || this.$route.name === 'tickets-details') {
            return { 'hoc-mobile-footer__active': true };
        } else {
            return { 'hoc-mobile-footer__active': false };
        }
    }

    public openStaffDialog() {
        this.openGlobalOverlay({
            title: this.$t('general.create-ticket', 'Create ticket'),
            rightButtonComponent: 'GlobalOverlayCloseButton',
            leftButtonComponent: 'GlobalOverlayEmptyButton',
            footerComponent: '',
            pageComponent: 'StaffCreateTicketForm',
        });
    }

    public footerGoTo(name: string) {
        if (this.$route.name !== name) {
            this.$router.push({ name });
        }
    }

    public closeOverlay() {
        const closeButtonAction = this.$store.getters['Viewport/getBottomNavigationCloseButton'];
        const closeButtonMutation = (Mutations as any)[closeButtonAction];

        this.$store.commit(closeButtonMutation, false);
        this.$store.commit(Mutations.SET_BOTTOM_NAVIGATION_CLOSE_BUTTON, '');
    }
}
